
import classnames from 'classnames';
import styles from './Consultation.module.css';
import Icon from '../../design-system/General/Icon';

export default function ConsultationSection({title, text, consults, sectionRef}) {
    return (
      <section className={styles['consult-section']} ref={sectionRef} id="consultation">
        <div className="container-lg">
          <div className="row">
            <div className="col-12 col-sm-11 col-lg-10 mx-auto">
              <div className={styles['consult-section_head']}>
                <h2 className={styles['consult-section_title']}>{title}</h2>
                <p className={styles['consult-section_text']}>{text}</p>
              </div>

              <div className="row consult-row">
                {consults.length > 0 && consults.map((s, index) => (
                  <div className="col-10 col-md-6 mx-auto">
                    <div className={classnames(
                        styles['consult-card'],
                        'd-flex flex-wrap',
                        {'flex-row-reverse' : index === 1 }
                        )
                      }>
                      <div className={classnames('col-12 col-sm-6')}>
                        {s.card_image && 
                          <figure className={styles['consult-card_thumb']}>
                            <img src={s.card_image.url} alt={s.card_title} width={s.card_image.width} height={s.card_image.height} />
                          </figure>
                        }
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className={styles['consult-card_inner']}>
                          <h3 className={styles['consult-card_title']}>
                              {s.card_title}
                          </h3>
                          <p>{s.card_text_line}</p>
                          <div 
                          className={styles['consult-card_attr']} 
                          dangerouslySetInnerHTML={{
                              __html: s.card_text,
                          }} />
                        </div>
                      </div>
                      <div className="col-12 text-center">
                         <a className="theme-button primary large" href={s.card_link}>
                            <span class="mas">{s.card_btn_title} <Icon name="icon-arrow-left" /></span>
                            <span class="btn">{s.card_btn_title} <Icon name="icon-arrow-left" /></span>
                          </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
          </div>
        </div>
      </section>
    );
}